import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import CancelButton from './cancel-button';
import AcceptedTerms from './accepted-terms';

const IsGuestBookingPaid = ({
  booking, disableButtons, onCancel, isHost,
}) => {
  return (
    <Box>
      <Box>
        <AcceptedTerms booking={booking} />
      </Box>
      &nbsp;
      <CancelButton
        {...{
          isHost, disableButtons, onCancel, booking,
        }}
      />
    </Box>
  );
};

IsGuestBookingPaid.propTypes = {
  disableButtons: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  isHost: PropTypes.bool.isRequired,
  booking: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default IsGuestBookingPaid;
